import { UpdateFloorPlanMemoDiagramParams, WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number, memoDiagramId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/rects/${memoDiagramId}/`;

export const updateFloorPlanMemoDiagram = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  memoDiagramId,
  coordinates,
  style,
}: WithBranchParams<UpdateFloorPlanMemoDiagramParams>) => {
  const url = createApiUrl(branchUid, floorPlanId, memoDiagramId);
  const { data } = await axiosInstance.patch(url, {
    coordinates,
    style: {
      fill: style.fill,
      border_color: style.borderColor ?? null,
      opacity: style.opacity,
    },
    version: branchVersionId,
  });

  return data;
};
